import Header from "@/components/enfinity/our-solutions/enfiniboost/Header";
import Content from "@/components/enfinity/our-solutions/enfiniboost/Content";
import Earning from "@/components/enfinity/our-solutions/enfiniboost/Earning";
import OldVideos from "@/components/enfinity/our-solutions/enfiniboost/OldVideos";
import MakeMoney from "@/components/enfinity/our-solutions/enfiniboost/MakeMoney";
import MSN from "@/components/enfinity/our-solutions/enfiniboost/MSN";
import Automated from "@/components/enfinity/our-solutions/enfiniboost/Automated";
import Requirements from "@/components/enfinity/our-solutions/enfiniboost/Requirements";
import Simple from "@/components/enfinity/our-solutions/enfiniboost/Simple";
import CTA from "@/components/enfinity/CTA";
import FAQ from "@/components/enfinity/Faq";
import Footer from "@/components/enfinity/Footer";
import scrollTo from "@/utils/scrollTo";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function EnfiniBoost() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const scrollId = location.state.scrollTo;
      // Clear the state immediately to prevent re-triggering
      navigate(location.pathname, { replace: true, state: {} });
      // Wait for DOM to be ready before scrolling
      setTimeout(() => {
        scrollTo(scrollId);
      }, 200);
    } else if (location.pathname === "/our-solutions/enfiniboost") {
      // Only scroll to top on direct navigation (not from scrollTo state)
      // Check if we just navigated here (no hash, no state)
      if (!location.hash && !location.state) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  }, [location, navigate]);

  return (
    <div className="bg-[#111111]">
      <Header />

      <Content />

      <Earning />

      <OldVideos />

      <MakeMoney />

      <MSN />

      <Automated />

      <Requirements />

      <Simple />

      <div>
        <CTA />
      </div>

      <div className="min-h-[900px] bg-white lg:pb-36 xxs:pb-60">
        <FAQ 
          faqs={[
          {
            question: "Who can use EnfiniBoost?",
            answer:
              "Creators producing original, high-quality content can use EnfiniBoost to reach new audiences and earn more than standard platform monetization allows.",
          },
          {
            question: "Do I need to make new videos for MSN?",
            answer:
              "No. We use your existing videos, long-form, Shorts, or TikToks. You don’t need to create anything new to start earning on MSN.",
          },
          {
            question: "Where exactly will my videos show up?",
            answer:
              "Your videos appear on MSN, Windows computers, Bing search, Microsoft Edge, and Copilot (Microsoft’s AI). That’s a lot of places for people to discover your content!",
          },
          {
            question: "Do I have to do anything after I get approved?",
            answer:
              "Nope! We take care of posting, formatting, and all technical work. You just keep making videos.",
          },
          ]}
        />
      </div>

      <Footer />
    </div>
  );
}

